import React from 'react';

import {Edit} from 'react-admin';

import CampaignChallengeForm from "./CampaignChallengeForm";

const CampaignChallengeEdit = (props) => (
    <Edit {...props}><CampaignChallengeForm/></Edit>
);

export default CampaignChallengeEdit;
